import React from 'react'
import { StyledQuestionButton as S } from './QuestionButton.styles'

export const QuestionButton: React.FC<React.PropsWithChildren> = ({
  children,
}) => <S.Wrapper>{children}</S.Wrapper>
